import React, { useEffect, useState } from 'react';
import { Dictionary } from 'lib';
import { useLocation } from 'react-router-dom';
import { newDictionary } from './dictionary-manager-helper';
import { HelixLoader } from '../../../components';
import { AttributeListContextProvider } from '../contexts/AttributeListContext';
import { IndexListContextProvider } from '../contexts/IndexListContext';
import { DictionaryManager } from './DictionaryManager';

export const CreateDictionary = (): React.JSX.Element => {
    const location = useLocation();
    const [dictionaryData, setDictionaryData] = useState<Dictionary>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setDictionaryData(newDictionary);
        setIsLoading(false);

        // location.state is only true if the dictionary was predicted successfully.
        if (location?.state) {
            const predictedDictionary: Dictionary = location?.state;
            setDictionaryData(predictedDictionary);
        }
    }, []);

    if (isLoading) {
        return <HelixLoader />;
    }

    return (
        <AttributeListContextProvider>
            <IndexListContextProvider>
                {dictionaryData ? (
                    <DictionaryManager
                        dictionaryData={dictionaryData}
                        isLoading={isLoading}
                        isEdit={false}
                        isPredicted={!!location?.state}
                    />
                ) : (
                    <></>
                )}
            </IndexListContextProvider>
        </AttributeListContextProvider>
    );
};
